import { createContext } from 'react'
import { AuthStatus } from '../types/auth.types'

export interface AuthState {
  authStatus: AuthStatus
}

export interface AuthContextType {
  authStatus: AuthStatus
  loading: boolean
  setAuthState: (state: Partial<AuthState>) => void
}

export const AuthContext = createContext<AuthContextType>({
  authStatus: 'loading',
  loading: false,
  setAuthState: () => {},
})
